/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SbSharedFollowSearchProvider_user$ref = any;
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type SbSharedFollowSearchProviderRefetchQueryVariables = {
    readonly followSearchPages?: ReadonlyArray<string | null> | null;
    readonly userId?: string | null;
    readonly followSearchTypes?: ReadonlyArray<types | null> | null;
};
export type SbSharedFollowSearchProviderRefetchQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly " $fragmentRefs": SbSharedFollowSearchProvider_user$ref;
        } | null;
    } | null;
};
export type SbSharedFollowSearchProviderRefetchQuery = {
    readonly response: SbSharedFollowSearchProviderRefetchQueryResponse;
    readonly variables: SbSharedFollowSearchProviderRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "followSearchPages",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "followSearchTypes",
            "type": "[types]",
            "defaultValue": [
                "SEARCH"
            ]
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SbSharedFollowSearchProviderRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SbSharedFollowSearchProvider_user",
                                    "args": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SbSharedFollowSearchProviderRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "favorites",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "pages",
                                            "variableName": "followSearchPages"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "types",
                                            "variableName": "followSearchTypes"
                                        }
                                    ],
                                    "concreteType": "favoritesConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "favoritesEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Favorite",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "serviceId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                (v2 /*: any*/)
                            ]
                        },
                        (v2 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SbSharedFollowSearchProviderRefetchQuery",
            "id": "app-buyer-finding/231.0.0-2019-09-05T14:31:07.563Z/SbSharedFollowSearchProviderRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'd72f0960c456b5e033153f82c76d24a1';
export default node;
